<odx-tab-bar (selectedTabChanged)="selectedTabIndex.set($event.selectedIndex)">
  <odx-tab-bar-item i18n="@@floorplan.details.flameDetector.tabBar.tab1">Allgemeine Informationen</odx-tab-bar-item>
  <odx-tab-bar-item i18n="@@floorplan.details.flameDetector.tabBar.tab2">Produkte</odx-tab-bar-item>
</odx-tab-bar>

@if (selectedTabIndex() === 0) {
  <div odxLayout="flex" class="flex-column">
    <h5 i18n="@@floorplan.details.flameDetector.title" class="odx-title-5">Allgemeine Informationen</h5>
    <div odxLayout="flex gap-none" class="flex-column">
      <form [formGroup]="editFlameDetectorForm" odxForm [readonly]="flameDetector().locked">
        <odx-form-field
          i18n-label="@@editFlameDetectorForm.label.sensitivity"
          label="Empfindlichkeit"
          [readonly]="noOptionsAvailable()"
        >
          <odx-select
            formControlName="sensitivity"
            odxFormFieldControl
            [placeholder]="noOptionsAvailable() ? noSensitivtyOptionsAvailablePlaceholder : ''"
          >
            @for (option of sensitivityOptions(); track option.value) {
              <odx-select-option [value]="option.value" [disabled]="!option.available">
                @if (option.available && option.detectionLength) {
                  {{ option.label }} ({{ option.detectionLength | number }}m)
                } @else {
                  {{ option.label }}
                }
              </odx-select-option>
            }
          </odx-select>
        </odx-form-field>
        <odx-form-field i18n-label="@@editFlameDetectorForm.label.mountingHeight" label="Montagehöhe">
          <input
            type="text"
            formControlName="mountingHeight"
            odxFormFieldControl
            i18n-placeholder="@@editFlameDetectorForm.placeholder.mountingHeight"
            placeholder="Montagehöhe"
          />
        </odx-form-field>
      </form>
    </div>
  </div>
}
@if (selectedTabIndex() === 1) {
  <app-floorplan-custom-part-numbers [floorplanItem]="flameDetector()"></app-floorplan-custom-part-numbers>
}
